import React from 'react'
import { Layers, Bot, Wand2, FlaskConical, GraduationCap, Building2 } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { WHY } from '../data'
const ICONS = { Layers, Bot, Wand2, FlaskConical, GraduationCap, Building2 }
export default function WhyChoose() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Why choose Kalki Ai Cloud Trading</Eyebrow>
          <SectionHeading align="center"
            title={<>Outcomes over <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">feature lists.</span></>}
            subtitle="Eight reasons trading businesses pick Kalki Ai Cloud when they’re ready to build a real product on real infrastructure."
          />
        </div>
        <FeatureGrid items={WHY} icons={ICONS} cols={4} />
      </Container>
    </section>
  )
}
